const addElementGroup = (group1, id, orderMemoryFlag, newArray, entityDocId, data, info, setField, group, setGroup) => {
    let nameGroup = `${entityDocId}_${id}_${group1}`
    let objArrayElement = {};
    let arrayFields = [];
    let objectsSubGroups = [];

    data.forEach((itemData) => {
        if (Number(itemData.id) === Number(id) && Number(itemData.entityDocId) === Number(entityDocId)) {

            itemData.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((itemFields, index) => {
                    if (itemFields.group !== null) {
                        itemFields.group.forEach((itemGroup, indexGroup) => {

                            if (itemGroup.name === group1 && indexGroup === 0) {

                                itemGroup.fields.forEach((item, m) => {

                                    if (item.subGroup !== null) {
                                        item.subGroup.forEach((itemSubGroupField) => {
                                            let objectSubGroup = {};
                                            let arrayFieldsSubgroup = [];
                                            let nameSubGroup = `subGroup_${itemData.entityDocId}_${itemData.id}_${itemSubGroupField.name}`;
                                            itemSubGroupField.fields.forEach((itemSubGroupFields, k) => {
                                                let itemFlag = JSON.parse(JSON.stringify(itemSubGroupFields));

                                                //let newIdField = `${itemData.entityDocId}_${itemData.id}_${itemSubGroupFields.id}_${item.subGroup.length}`;
                                                let tamano = 0;
                                                if (group[nameGroup])
                                                    tamano = group[nameGroup].length;

                                                if (newArray)
                                                    tamano = newArray.length;

                                                let newIdField = `${itemData.entityDocId}_${itemData.id}_${itemSubGroupFields.id}_${tamano}`;

                                                itemFlag.id = newIdField;
                                                itemFlag.isGroup = true;

                                                //buscar y reemplazar id de los where
                                                if (itemFlag.where !== null) {
                                                    for (let r = 0; r < itemFlag.where.length; r++) {
                                                        if (itemFlag.where[r].field.length !== null) {
                                                            for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                                let idField = itemFlag.where[r].field[d].idField;
                                                                itemSubGroupField.fields.forEach((itemSubGroupFields1, ñ) => {
                                                                    if (itemSubGroupFields1.id === idField) {
                                                                        let newIdField1 = `${itemData.entityDocId}_${itemData.id}_${itemSubGroupFields1.id}_${tamano}`;

                                                                        itemFlag.where[r].field[d].idField = newIdField1;
                                                                    }
                                                                })

                                                            }
                                                        }
                                                    }
                                                }

                                                arrayFieldsSubgroup.push(itemFlag);
                                                switch (itemFlag.type) {
                                                    case 'Select':
                                                        if (itemFlag.defaultValue) {
                                                            info.forEach((itemInfo) => {
                                                                if (itemInfo.source === itemFlag.sourceSelect) {
                                                                    if (Number(itemFlag.defaultValue) === Number(itemInfo.id))
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                }
                                                            })
                                                        } else {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: null
                                                            }));
                                                        }
                                                        break;
                                                    case 'MultipleSelect':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: null
                                                        }));
                                                        break;
                                                    case 'List':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: null
                                                        }));
                                                        break;
                                                    case 'Checkbox':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: false
                                                        }));
                                                        break;
                                                    case 'Switch':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: false
                                                        }));
                                                        break;
                                                    case 'Number':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: 0
                                                        }));
                                                        break;
                                                    case 'Currency':
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: 0.00
                                                        }));
                                                        break;
                                                    case 'Date':
                                                        if (itemFlag.defaultValue === 'CURDATE()') {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: new Date().toISOString().split('T')[0]
                                                            }), []);
                                                        } else {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: ''
                                                            }));
                                                        }
                                                        break;
                                                    default:
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: ''
                                                        }));
                                                        break;
                                                }

                                            })
                                            objectSubGroup.fields = arrayFieldsSubgroup;
                                            objectSubGroup.id = itemData.id;
                                            objectSubGroup.name = nameSubGroup;
                                            objectsSubGroups.push({
                                                [nameSubGroup]: [objectSubGroup]
                                            });
                                        })
                                    }
                                    else {
                                        let itemFlag = JSON.parse(JSON.stringify(item));

                                        let nameGroupFlag = nameGroup.split('_');

                                        let tamano = 0;
                                        if (group[nameGroup])
                                            tamano = group[nameGroup].length;

                                        if (newArray)
                                            tamano = newArray.length;

                                        let newIdField = `${nameGroupFlag[0]}_${nameGroupFlag[1]}_${item.id}_${tamano}`;

                                        itemFlag.id = newIdField;
                                        itemFlag.isGroup = true;
                                        //buscar y reemplazar id de los where
                                        if (itemFlag.where !== null) {
                                            for (let r = 0; r < itemFlag.where.length; r++) {
                                                if (itemFlag.where[r].field.length !== null) {
                                                    for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                        let idField = itemFlag.where[r].field[d].idField;
                                                        itemGroup.fields.forEach((itemFlagFieldsGroup) => {
                                                            if (itemFlagFieldsGroup.id === idField) {

                                                                let newIdField1 = `${nameGroupFlag[0]}_${nameGroupFlag[1]}_${itemFlagFieldsGroup.id}_${tamano}`;

                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                            }
                                                        })

                                                    }
                                                }
                                            }
                                        }

                                        arrayFields.push(itemFlag);
                                        let valueOrderMemoryField;
                                        let fullNameEntity;
                                        if (orderMemoryFlag !== null && orderMemoryFlag !== undefined) {

                                            if (group1 === 'Errores') {
                                                if (item.name === 'N° Documento') {
                                                    valueOrderMemoryField = orderMemoryFlag.documento;
                                                }
                                                if (item.name === 'Error') {
                                                    valueOrderMemoryField = orderMemoryFlag.error;
                                                }
                                            } else {
                                                for (let p = 0; p < orderMemoryFlag.boxes.length; p++) {
                                                    for (let l = 0; l < orderMemoryFlag.boxes[p].fields.length; l++) {
                                                        if (nameGroup !== '11_Cargo') {
                                                            if ((orderMemoryFlag.boxes[p].fields[l].idFieldTable === item.idFieldTable) && orderMemoryFlag.boxes[p].fields[l].value) {
                                                                if (item.idFieldTable !== null)
                                                                    valueOrderMemoryField = orderMemoryFlag.boxes[p].fields[l].value;
                                                            }
                                                        }
                                                        else {
                                                            if (orderMemoryFlag.boxes[p].fields[l].idFieldTable === 'fullName' && item.name === 'Apoderado') {
                                                                valueOrderMemoryField = { id: orderMemoryFlag.idEntity, label: orderMemoryFlag.boxes[p].fields[l].value }
                                                            }
                                                        }
                                                        if (orderMemoryFlag.boxes[p].fields[l].idFieldTable === 'fullName') {
                                                            fullNameEntity = orderMemoryFlag.boxes[p].fields[l].value;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if (!valueOrderMemoryField && group1 === 'Cargo') {
                                            data.forEach((itemDataFlag) => {

                                                if (itemDataFlag.entityDocId === '8') {

                                                    itemDataFlag.boxes.forEach((itemBoxsFlag) => {

                                                        itemBoxsFlag.fields.forEach((itemFieldsFlag) => {

                                                            if (itemFieldsFlag.group !== null) {
                                                                itemFieldsFlag.group.forEach((itemGroupFlag) => {
                                                                    let existeFlag = false;
                                                                    itemGroupFlag.fields.forEach((itemGroupFieldsFlag) => {

                                                                        if (itemGroupFieldsFlag.idFieldTable === 'fullName') {
                                                                            if (itemGroupFieldsFlag.value === fullNameEntity) {
                                                                                existeFlag = true;
                                                                            }
                                                                        }
                                                                    })
                                                                    if (existeFlag === true) {
                                                                        itemGroupFlag.fields.forEach((itemGroupFieldsFlag) => {
                                                                            if (item.idFieldTable === itemGroupFieldsFlag.idFieldTable) {
                                                                                if (itemGroupFieldsFlag.idFieldTable === 'argIsPep') {
                                                                                    valueOrderMemoryField = itemGroupFieldsFlag.value;
                                                                                }
                                                                                if (itemGroupFieldsFlag.idFieldTable === 'argPepArt') {
                                                                                    valueOrderMemoryField = itemGroupFieldsFlag.value;
                                                                                }
                                                                                if (itemGroupFieldsFlag.name === 'Observaciones') {
                                                                                    valueOrderMemoryField = itemGroupFieldsFlag.value;
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }

                                        if (item.type !== 'Typography') {

                                            switch (item.type) {
                                                case 'Select':
                                                    if (item.defaultValue) {
                                                        info.forEach((itemInfo) => {
                                                            if (itemInfo.source === item.sourceSelect) {
                                                                if (Number(item.defaultValue) === Number(itemInfo.id))
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [newIdField]: {
                                                                            id: itemInfo.id,
                                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                        }
                                                                    }), []);
                                                            }
                                                        })
                                                    } else {
                                                        if (valueOrderMemoryField) {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: valueOrderMemoryField
                                                            }));
                                                        } else {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: null
                                                            }));
                                                        }
                                                    }
                                                    break;
                                                case 'MultipleSelect':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: null
                                                    }));
                                                    break;
                                                case 'List':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: null
                                                    }));
                                                    break;
                                                case 'Checkbox':

                                                    if (valueOrderMemoryField) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: valueOrderMemoryField
                                                        }));
                                                    } else {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: false
                                                        }));
                                                    }
                                                    break;
                                                case 'Switch':

                                                    if (valueOrderMemoryField !== 'false') {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: valueOrderMemoryField
                                                        }));
                                                    } else {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: false
                                                        }));
                                                    }

                                                    break;
                                                case 'Number':
                                                    if (valueOrderMemoryField) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: valueOrderMemoryField
                                                        }));
                                                    } else {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: 0
                                                        }));
                                                    }
                                                    break;
                                                case 'Currency':
                                                    if (valueOrderMemoryField) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: valueOrderMemoryField
                                                        }));
                                                    } else {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: 0.00
                                                        }));
                                                    }
                                                    break;
                                                case 'Date':
                                                    if (item.defaultValue === 'CURDATE()') {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: new Date().toISOString().split('T')[0]
                                                        }), []);
                                                    } else {
                                                        if (valueOrderMemoryField) {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: valueOrderMemoryField
                                                            }));
                                                        } else {
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: ''
                                                            }));
                                                        }
                                                    }
                                                    break;
                                                default:
                                                    if (valueOrderMemoryField) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: valueOrderMemoryField
                                                        }));
                                                    } else {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [newIdField]: ''
                                                        }));
                                                    }
                                                    break;
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                })
            })
        }
    })

    objArrayElement.fields = arrayFields;
    objArrayElement.id = id;
    objArrayElement.name = group1;
    objArrayElement.subGroup = objectsSubGroups;
    if (orderMemoryFlag)
        objArrayElement.idDocumentError = orderMemoryFlag.idDocumento;

    if (newArray === undefined || newArray === null) {
        setGroup(prevState => ({
            ...prevState,
            [nameGroup]: [...group[nameGroup], objArrayElement]
        }));
    } else {
        newArray.push(objArrayElement);
    }
}

const addElementSubGroup = (group1, id, nameSubGroup, indexGroup, indexItemSubGroupFields, data, info, setField, group, setGroup, object, newArray, idAdjunto, dataDocumentation) => {

    let subGroup = nameSubGroup.split('_')[3] + '_' + nameSubGroup.split('_')[4];
    if (nameSubGroup.split('_')[4] !== 'opc' && nameSubGroup.split('_')[4] !== 'Socio' && nameSubGroup.split('_')[4] !== 'BF')
        subGroup = nameSubGroup.split('_')[4]


    let nameGroup;
    let objArrayElement = {};
    let arrayFields = [];
    data.forEach((itemData) => {
        if (itemData.id === id) {
            nameGroup = `${itemData.entityDocId}_${itemData.id}_${group1}`

            if (idAdjunto) {
                for (let b = 0; b < dataDocumentation.length; b++) {
                    if (Number(dataDocumentation[b].id) === Number(idAdjunto)) {
                        itemData = dataDocumentation[b];
                    }
                }
            }
            itemData.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((itemFields, index) => {
                    if (itemFields.group !== null) {
                        itemFields.group.forEach((itemGroup) => {
                            if (itemGroup.name === group1) {
                                itemGroup.fields.forEach((itemGroupFields) => {
                                    if (itemGroupFields.subGroup !== null) {
                                        itemGroupFields.subGroup.forEach((itemSubGroup) => {

                                            if (itemSubGroup.name === subGroup) {
                                                itemSubGroup.fields.forEach((item) => {
                                                    let itemFlag = JSON.parse(JSON.stringify(item));
                                                    let entityDocFlag = itemData.entityDocId
                                                    if (itemData.entityDocId.length > 1) {
                                                        entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                                                    }
                                                    let newIdField = entityDocFlag + index + '_' + entityDocFlag + item.id + '_' + index + indexItemSubGroupFields + '_' + nameSubGroup.split('_')[3] + '_' + indexGroup;

                                                    itemFlag.id = newIdField;
                                                    itemFlag.isGroup = true;
                                                    //buscar y reemplazar id de los where
                                                    if (itemFlag.where !== null) {
                                                        for (let r = 0; r < itemFlag.where.length; r++) {
                                                            if (itemFlag.where[r].field.length !== null) {
                                                                for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                                    let idField = itemFlag.where[r].field[d].idField;
                                                                    itemSubGroup.fields.forEach((itemFlagFieldsGroup) => {
                                                                        if (itemFlagFieldsGroup.id === idField) {
                                                                            //let tamano1 = group[nameGroup].length;
                                                                            let entityDocFlag = itemData.entityDocId
                                                                            if (itemData.entityDocId.length > 1) {
                                                                                entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                                                                            }
                                                                            let newIdField1 = entityDocFlag + index + '_' + entityDocFlag + itemFlagFieldsGroup.id + '_' + index + indexItemSubGroupFields + '_' + nameSubGroup.split('_')[3] + '_' + indexGroup;
                                                                            itemFlag.where[r].field[d].idField = newIdField1;
                                                                        }
                                                                    })

                                                                }
                                                            }
                                                        }
                                                    }

                                                    arrayFields.push(itemFlag);

                                                    let valueObject = null;
                                                    if (object) {
                                                        object.fields.forEach((itemsObjectsFields) => {
                                                            if (itemsObjectsFields.idFieldTable === item.idFieldTable) {
                                                                valueObject = itemsObjectsFields.value;
                                                            }
                                                        })
                                                    }
                                                    switch (item.type) {
                                                        case 'Select':
                                                            if (item.defaultValue) {
                                                                info.forEach((itemInfo) => {
                                                                    if (itemInfo.source === item.sourceSelect) {
                                                                        if (Number(item.defaultValue) === Number(itemInfo.id))
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [newIdField]: {
                                                                                    id: itemInfo.id,
                                                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                }
                                                                            }), []);
                                                                    }
                                                                })
                                                            } else {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: null
                                                                }));
                                                            }
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'MultipleSelect':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: null
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'List':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: null
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'Checkbox':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: false
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'Switch':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: false
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'Number':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: 0
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'Currency':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: 0.00
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        case 'Date':
                                                            if (item.defaultValue === 'CURDATE()') {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: new Date().toISOString().split('T')[0]
                                                                }), []);
                                                            } else {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: ''
                                                                }));
                                                            }
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                        default:
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: ''
                                                            }));
                                                            if (valueObject)
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: valueObject
                                                                }));
                                                            break;
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            })
        }
    })

    objArrayElement.fields = arrayFields;
    objArrayElement.id = id;
    objArrayElement.name = nameSubGroup;

    addSubGroupElement(objArrayElement, nameGroup, nameSubGroup, indexGroup, group, setGroup, newArray);

}

const addSubGroupElement = (objArrayElement, nameGroup, nameSubGroup, indexGroup, group, setGroup, newArray) => {
    // Clonar el objeto 'group' para evitar mutar el estado directamente
    let groupActualizado = { ...group };
    if (newArray) {
        groupActualizado = {
            [newArray[0].name]: newArray
        }
    }

    // Encontrar el índice del objeto 'subGroup_4_Domicilios' en el array
    //const subGroupDomiciliosIndice = groupActualizado[nameGroup][0].subGroup.findIndex(

    const subGroupDomiciliosIndice = groupActualizado[nameGroup][indexGroup].subGroup.findIndex(
        (subGroup) => nameSubGroup in subGroup
    );
    if (subGroupDomiciliosIndice !== -1) {

        const subGroupDomiciliosActualizado = [
            //...groupActualizado[nameGroup][0].subGroup[subGroupDomiciliosIndice][nameSubGroup],
            ...groupActualizado[nameGroup][indexGroup].subGroup[subGroupDomiciliosIndice][nameSubGroup],
        ];

        // Agregar el nuevo domicilio al array
        subGroupDomiciliosActualizado.push(objArrayElement);

        // Actualizar el array de 'subGroup_4_Domicilios' en el objeto 'group'
        //groupActualizado[nameGroup][0].subGroup[subGroupDomiciliosIndice][nameSubGroup] = subGroupDomiciliosActualizado;
        groupActualizado[nameGroup][indexGroup].subGroup[subGroupDomiciliosIndice][nameSubGroup] = subGroupDomiciliosActualizado;

        // Setear el objeto actualizado en el hook 'group'
        if (newArray === undefined || newArray === null) {
            setGroup(groupActualizado);
        }
    } else {
        console.error("No se encontró el subGroup_4_Domicilios en el objeto.");
    }
};

const groupFunctions = {
    addElementGroup,
    addElementSubGroup
}

export default groupFunctions;